<div class="modal-header d-flex justify-content-between border-bottom">
  <h5 class="modal-title" *ngIf="cancleButtonText">{{ title }}</h5>
      <span><i class="fa-solid fa-xmark fa-2xl hover-box cursor"  (click)="closeModal()"></i></span>

</div>
<div class="modal-body text-center set">
  <p class="">{{ confirmText }}</p>
  <ng-template #elseBlock>
    <p>{{ confirmText }}</p>
  </ng-template>
<div class="d-flex justify-content-end">
  <button
    type="button"
    class="btn btn-outline-primary me-2 float-right btn-padding"
    (click)="choice(true)"
  >
    {{ acceptButtonText }}
  </button>

  <button
    type="button"
    class="btn btn-outline-secondary float-right btn-padding"
    (click)="choice(false)"
  >
    {{ cancleButtonText }}
  </button>
</div>
</div>
